import TableCell from '@mui/material/TableCell';
import PropTypes from 'prop-types';

const CenterTableCell = (props) => {
  const { text, className, onClick, style } = props;
  return (
    <TableCell style={style} onClick={onClick} className={className} align={'center'}>
      {text}
    </TableCell>
  );
};

CenterTableCell.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default CenterTableCell;
